import type { UnknownAction, Reducer } from '@reduxjs/toolkit';

const HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__';

interface Action extends UnknownAction {
  type: typeof HYDRATE;
  payload: Record<string, unknown>;
}

/**
 * hydrateReducer
 * @param reducer
 * @param initialState
 */
export const hydrateReducer =
  <S extends Record<string, unknown>, IS extends S>(
    reducer: Reducer<S>,
    initialState: IS
  ): Reducer<S> =>
  // eslint-disable-next-line default-param-last
  (state = initialState, action: UnknownAction) => {
    switch (action.type) {
      case HYDRATE:
        return { ...state, ...(action as Action).payload };
      default:
        return reducer(state, action);
    }
  };
